import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { DateRangePicker } from '@calendly/ui/components/date-range-picker';
import { useClose } from '@calendly/ui/components/dropdown';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useState, forwardRef } from 'react';
import { Bookmarks } from './bookmarks';
const controlButtonIsTabletUpCss = "c1x0sbdx";
const controlButtonCss = "c1f2mdc8";
const ControlButton = forwardRef((props, ref) => {
  const isTabletUp = useDeviceType('isTabletUp');
  return <Button ref={ref} {...props} className={classNames(controlButtonCss, {
    [controlButtonIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
const footerIsTabletUpCss = "fbq5e8p";
const footerCss = "f1mi8528";
const Footer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(footerCss, {
    [footerIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
export const Picker = ({
  startDate,
  endDate,
  timezone,
  onChange,
  period,
  isMIPage
}) => {
  const [currentStartDate, setCurrentStartDate] = useState(startDate);
  const [currentEndDate, setCurrentEndDate] = useState(endDate);
  const closePicker = useClose();
  const handleChange = ([start, end]) => {
    setCurrentStartDate(start);
    setCurrentEndDate(end);
    if (isMIPage) {
      onChange({
        period: 'fixed',
        startDate: start,
        endDate: end
      });
      closePicker();
    }
  };
  const onSave = () => {
    onChange({
      period: 'fixed',
      startDate: currentStartDate,
      endDate: currentEndDate
    });
    closePicker();
  };
  return <>
      <Bookmarks isMIPage={isMIPage} period={period} onChange={onChange} />
      <DateRangePicker timezone={timezone} startDate={currentStartDate} endDate={currentEndDate} onChange={handleChange} />
      {!isMIPage && <Footer>
        <ControlButton onClick={closePicker} decoration="ghost">
          {I18n.t('publisher.action.cancel')}
        </ControlButton>
        <ControlButton onClick={onSave} disabled={!currentStartDate || !currentEndDate}>
          {I18n.t('publisher.action.apply')}
        </ControlButton>
      </Footer>}
    </>;
};

require("./picker.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./picker.js");